export const myMapStyles = {
  gmap: {
    height: '360px',
    width: '100%',
  },
  blockMargin: {
    height: '360px',
    width: '100%',
  },
  bxYandexViewLayout: {
    height: '360px',
    width: '100%',
  },
  bxYandexViewMap: {
    height: '360px',
    width: '100%',
  },
  gmapPointer: {
    height: '360px',
    width: '100%',
  },
  bxGoogleMap: {
    height: '360px',
    width: '100%',
    border: "2px solid #002f2f",
    borderRadius: "10px",
    overflow: "hidden",
    outline: "5px solid #002f2f",
    outlineOffset: "2px",
    boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
    marginBottom: "10px",
    marginTop: "10px",
    marginLeft: "10px",
    marginRight: "10px",
  },
  gmapPointerIcon: {
    height: '360px',
    width: '100%',
  },
  gmapPointerBody: {
    height: '360px',
    width: '100%',
  },
  iconSvg: {
    height: '360px',
    width: '100%',
  },
  colorBlack: {
    color: 'black',
  },
}